// NextScene - Razorpay checkout helper
// Works in two modes:
//   1. MOCK  – order.mock === true  → simulates a successful payment (no real charge)
//   2. LIVE  – order.mock === false → loads Razorpay checkout.js and opens the real modal
export async function openCheckout(order, onSuccess) {
  if (order?.mock) {
    // MOCK mode – simulate a short delay + success
    await new Promise((r) => setTimeout(r, 900));
    await onSuccess({
      order_id: order.order_id,
      payment_id: `pay_mock_${Date.now()}`,
      signature: "mock_sig",
    });
    return;
  }
  if (!window.Razorpay) {
    await new Promise((res, rej) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = res;
      s.onerror = () => rej(new Error("Failed to load Razorpay"));
      document.body.appendChild(s);
    });
  }
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "NextScene",
      description: order.kind === "verification" ? "Verified Badge Application" : `${(order.plan || "").toUpperCase()} Plan`,
      theme: { color: "#DC2626" },
      handler: async (resp) => {
        try {
          await onSuccess({
            order_id: resp.razorpay_order_id,
            payment_id: resp.razorpay_payment_id,
            signature: resp.razorpay_signature,
          });
          resolve();
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.open();
  });
}
